/**
 * 生产安全 · 设备运行详情（/safety-device/:name）字段模型
 * 后台按区块分组展示可编辑字段（中文 label + 类型 + 默认值），前端用 $C / $CList 读取。
 * 注意：本页由路由参数 :name 决定显示哪台设备。设备专属文本/指标随设备数组整体外部化，
 * 默认取 SAFETY_DEVICES（首台「原料粉碎」即默认/未匹配时的设备）内容作为各设备默认值。
 */
import { SAFETY_DEVICES } from '@/data/productionSafety'

// 逐设备监控视频：每行一台设备，填「video」即替换该设备详情页的监控视频；留空则用下方全局默认。
// key / name 仅用于定位与显示，请勿修改。
const DEVICE_VIDEOS = SAFETY_DEVICES.map(d => ({ key: d.key, name: d.name, video: '' }))

export default {
  title: '设备运行详情',
  groups: [
    {
      title: '页头区域',
      fields: [
        { key: 'titleSub', label: '标题副文案', type: 'text', default: '设备运行实况' },
        { key: 'backText', label: '返回按钮', type: 'text', default: '返回设备列表' },
      ],
    },
    {
      title: '右侧状态面板',
      fields: [
        { key: 'stateLabel', label: '状态行·标签', type: 'text', default: '设备开' },
        { key: 'stateValue', label: '状态行·运行状态', type: 'text', default: '运行正常' },
        { key: 'liveText', label: '监控角标', type: 'text', default: '实时监控' },
      ],
    },
    {
      title: '数据指标（设备清单，可整体编辑各设备文本与指标）',
      fields: [
        { key: 'devices', label: '设备列表数据（每行一台设备：name 设备名 / camera 角标 / desc 底部说明 / metrics 运行指标——点「逐项编辑」按数据框修改：指标名、单位、数值、最小/最大、小数位）', type: 'array', default: SAFETY_DEVICES },
      ],
    },
    {
      title: '逐设备监控视频（按设备填写，留空用全局默认）',
      fields: [
        { key: 'deviceVideos', label: '各设备视频（key/name 勿改，video 列可直接本地上传或从素材库选择）', type: 'array', default: DEVICE_VIDEOS },
      ],
    },
    {
      title: '图片与视频',
      fields: [
        { key: 'videoUrl', label: '全局默认监控视频（各设备未单独配置时使用）', type: 'video', default: process.env.BASE_URL + 'assets/ai/ai.webm' },
      ],
    },
  ],
}
